import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rapid-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
